import { SidebarService } from './sidebar.service';
import { AuthService } from './auth.service';
import { UserService } from './user.service';
import { DataService } from './data.service';
import { JobsService } from './jobs.service';
import { JwtService } from './jwt.service';
import { ApiService } from './api.service';

export const services: any[] = [SidebarService, AuthService, JwtService, ApiService, UserService, DataService, JobsService];

export * from './sidebar.service';
export * from './auth.service';
export * from './jwt.service';
export * from './api.service';
export * from './user.service';
export * from './data.service';
export * from './jobs.service';
